import { GetStaticPaths, GetStaticProps } from 'next'
import { pageUtil } from '@/services/api/pageUtil'

export const getStaticPaths: GetStaticPaths = async () => {
  return pageUtil.getPayoutPageStaticPaths()
}

export const getStaticProps: GetStaticProps = async (context) => {
  return pageUtil.getPayoutPageProps({
    slug: context?.params?.slug as string,
  })
}

export { default } from '@/components/pages/payout/PayoutPage'
